module.exports = __webpack_public_path__ + "img/money-collect.bcf4842e.svg";